/**
 * Mega Menu New – left/right column navigation.
 *
 * Listeners are scoped to [data-mega-menu-new] elements (not the whole document).
 * A MutationObserver on the header section re-inits after section hydration.
 *
 * Keyboard: ArrowDown/Up (wrap), Home/End, Tab into panel, Escape (parent)
 * Pointer:  pointerenter activates panel
 */

function activatePanel(menu, trigger) {
  const panelId = trigger.getAttribute('data-mega-new-panel-id');
  const triggers = menu.querySelectorAll('[data-mega-new-trigger]');
  const panels = menu.querySelectorAll('[data-mega-new-panel]');

  triggers.forEach((t) => {
    const isMatch = t === trigger;
    t.classList.toggle('is-active', isMatch);
    t.setAttribute('aria-selected', String(isMatch));
    t.setAttribute('tabindex', isMatch ? '0' : '-1');
  });

  panels.forEach((panel) => {
    const isMatch = panel.getAttribute('data-mega-new-panel-id') === panelId;
    if (isMatch) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  });

  // Update banner visibility based on active tab handle
  const handle = trigger.getAttribute('data-lvl2-handle');
  const bannerContainer = menu.querySelector('.mega-menu-new__panel-banner');
  if (bannerContainer) {
    // Remove data-first-handle so CSS initial-state rule stops applying
    bannerContainer.removeAttribute('data-first-handle');
    bannerContainer.querySelectorAll('.mega-menu-new__banner').forEach((b) => {
      b.hidden = b.getAttribute('data-banner-handle') !== handle;
    });
  }
}

function initMenu(menu) {
  if (menu.dataset.megaMenuNewInit) return;
  menu.dataset.megaMenuNewInit = 'true';

  // Banner for the first tab is shown by CSS (data-first-handle match).
  // activatePanel() removes data-first-handle on hover so CSS stops and JS takes over.

  // Pointer hover (capture – pointerenter doesn't bubble)
  menu.addEventListener('pointerenter', (e) => {
    const trigger = e.target.closest('[data-mega-new-trigger]');
    if (trigger) activatePanel(menu, trigger);
  }, true);

  // Keyboard focus
  menu.addEventListener('focusin', (e) => {
    const trigger = e.target.closest('[data-mega-new-trigger]');
    if (trigger) activatePanel(menu, trigger);
  });

  // Keyboard arrow navigation
  menu.addEventListener('keydown', (e) => {
    const trigger = e.target.closest('[data-mega-new-trigger]');
    if (!trigger) return;

    const triggers = Array.from(menu.querySelectorAll('[data-mega-new-trigger]'));
    const currentIndex = triggers.indexOf(trigger);
    let nextIndex = -1;

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        nextIndex = currentIndex + 1 >= triggers.length ? 0 : currentIndex + 1;
        break;
      case 'ArrowUp':
        e.preventDefault();
        nextIndex = currentIndex - 1 < 0 ? triggers.length - 1 : currentIndex - 1;
        break;
      case 'Home':
        e.preventDefault();
        nextIndex = 0;
        break;
      case 'End':
        e.preventDefault();
        nextIndex = triggers.length - 1;
        break;
      default:
        return;
    }

    if (nextIndex >= 0) {
      triggers[nextIndex].focus();
    }
  });
}

function initAllMegaMenus() {
  document.querySelectorAll('[data-mega-menu-new]').forEach(initMenu);
}

document.addEventListener('DOMContentLoaded', () => {
  initAllMegaMenus();

  // Re-init after section hydration replaces DOM content
  const header = document.querySelector('.header-section');
  if (header) {
    const observer = new MutationObserver(() => initAllMegaMenus());
    observer.observe(header, { childList: true, subtree: true });
  }
});
